import SurgicalTab from "../../../../patient/details/surgical/SurgicalTab";

export default function ASCDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <SurgicalTab inWorkQ={inWorkQ} />
    </div>
}
